// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ZoomToSelectionIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ZoomToSelectionIcon" ref={forwardedRef} {...props}>
      <path d="M3.5 5.424V3.5h1.929V2H3a1 1 0 0 0-1 1v2.424z" />
      <path d="M16.5 3.5h-1.929V2H17a1 1 0 0 1 1 1v2.424h-1.5z" />
      <path d="M16.5 14.571H18V17a1 1 0 0 1-1 1h-2.429v-1.5H16.5z" />
      <path d="M5.429 16.5H3.5v-1.929H2V17a1 1 0 0 0 1 1h2.429z" />
      <path d="M9 13.5a4.5 4.5 0 0 0 2.572-.807l1.989 1.989a.75.75 0 1 0 1.06-1.06l-1.978-1.98A4.5 4.5 0 1 0 9 13.5M9 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
    </SvgIcon>
  );
});

/**
 * Zoom to manually selected area
 * @public
 */
export const ZoomToSelectionIcon = /* @__PURE__ */ Object.assign(
  ZoomToSelectionIconComponent,
  { displayName: 'ZoomToSelectionIcon' },
);
